window._ = require("lodash")
import "regenerator-runtime/runtime.js";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import {initDeviceFingerprint} from "./services/deviceFingerprint";
import "./services/firebaseMessaging";

initDeviceFingerprint();
